import environment from "@web-app/src/environments/environment";

type Props = {
  eventSlug: string | null;
};

// Paying through Up2Pay inside a third-party iframe can fail on mobile (cramped 3DS step,
// blocked third-party cookies); the event page on Connect'Events pays top-level.
export const EmbedPayOnSiteLink = ({ eventSlug }: Props) => {
  if (!eventSlug) {
    return null;
  }

  return (
    <p className="text-center text-sm">
      Un souci pour payer ?{" "}
      <a
        href={`${environment.NEXT_BASE_URL}/event/${eventSlug}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 underline"
      >
        Achetez directement sur Connect&apos;Events
      </a>
    </p>
  );
};
